module.exports = __webpack_public_path__ + "static/media/dashboard-icon-active.1a2552da.svg";